export function operacaoConsultaLogLiberacaoSiadInRequest(params = {}) {
  return {
    type: '@operacaoprerecebimentolista/CONSULTALOGLIBERACAOSIAD_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoConsultaLogLiberacaoSiad(loli_codigo) {
  return {
    type: '@operacaoconsultalogliberacaosiad/FIND_CONSULTALOGLIBERACAOSIAD',
    payload: { loli_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoconsultalogliberacaosiad/FAILED_REQUEST',
  };
}

export function deleteOperacaoConsultaLogLiberacaoSiad(loli_codigo, params) {
  return {
    type: '@operacaoconsultalogliberacaosiad/DELETE_CONSULTALOGLIBERACAOSIAD',
    payload: { loli_codigo, params },
  };
}

export function updateOperacaoConsultaLogLiberacaoSiad(operacaoconsultalogliberacaosiad, params) {
  return {
    type: '@operacaoconsultalogliberacaosiad/UPDATE_CONSULTALOGLIBERACAOSIAD',
    payload: { operacaoconsultalogliberacaosiad, params },
  };
}

export function storeOperacaoConsultaLogLiberacaoSiad(operacaoconsultalogliberacaosiad, params) {
  return {
    type: '@operacaoconsultalogliberacaosiad/STORE_CONSULTALOGLIBERACAOSIAD',
    payload: { operacaoconsultalogliberacaosiad, params },
  };
}

export function successInRequest(
  operacaoconsultalogliberacaosiad,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoconsultalogliberacaosiad/SUCCESS_IN_REQUEST',
    payload: { operacaoconsultalogliberacaosiad, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaoconsultalogliberacaosiad) {
  return {
    type: '@operacaoconsultalogliberacaosiad/SUCCESS_REQUEST',
    payload: { operacaoconsultalogliberacaosiad },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoconsultalogliberacaosiad/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoconsultalogliberacaosiad/RECORD_FILTERING',
    payload: { params },
  };
}
